import { RootState } from "@helpers/store/store";
import { TypedUseSelectorHook, useSelector } from "react-redux";

/**
 * Works just like the `useSelector` hook from react-redux, with the only 
 * difference being that the store parameter in the passed callback
 * will expose the store type internals
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;